import { FC } from "react";

export const CartItemMoreInfo: FC<{ d: BookingState }> = ({ d }) => {
  // TODO: cart more info text;
  return null;
  // const product = d.product;
  // product.bookingDetails.bookingAttributes.productAttribute
  // if (product.productType === PRODUCT_TYPES.SIM) {
  //   return (
  //     <>
  //       <p className="text-[0.875rem] leading-[1.25rem] font-normal text-[#5E6D77] mb-1">
  //         {attachNumPrefix(product.bookingInfo?.qtySim, "E-sim")}
  //       </p>
  //     </>
  //   );
  // } else if (product.productType === PRODUCT_TYPES.TOUR) {
  //   return (
  //     <>
  //       <p className="text-[0.875rem] leading-[1.25rem] font-normal text-[#5E6D77] mb-1">
  //         {[
  //           attachNumPrefix(product.bookingInfo?.qtyAdult, "adult", "adults"),
  //           attachNumPrefix(product.bookingInfo?.qtyChild, "child", "children"),
  //         ]
  //           .filter(Boolean)
  //           .join(" ,")}
  //       </p>
  //     </>
  //   );
  // }
  // return (
  //   <p className="text-[0.875rem] leading-[1.25rem] font-normal text-[#5E6D77] mb-1">
  //     {[
  //       attachNumPrefix(product.bookingInfo?.qtyAdult, "adult", "adults"),
  //       attachNumPrefix(product.bookingInfo?.qtyChild, "child", "children"),
  //     ]
  //       .filter(Boolean)
  //       .join(" ,")}
  //   </p>
  // );
};
